import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=ebb6742c&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports